const listeners = new Set();

export function emitDataMutation(event = {}) {
  listeners.forEach((listener) => {
    try {
      listener({
        timestamp: Date.now(),
        ...event,
      });
    } catch (_error) {
      // Guard against one broken listener blocking the rest.
    }
  });
}

export function subscribeDataMutation(listener) {
  if (typeof listener !== 'function') {
    return () => {};
  }

  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
